import { DataProvider, GetListParams, GetListResult } from 'react-admin';
import { adsProxy } from './apiGateway';

interface ModerationAd {
    id: string;
    lastUpdateDate: string;
    aiModerationState?: string;
    adDetails: {
        countOfPhoto: number;
        brandName: string;
        modelName: string;
        price: string;
    };
    meta?: {
        cursor?: string | null;
    };
}

interface ModerationAdsApiResponse {
    success: boolean;
    body: {
        response: ModerationAd[];
        cursor: string | null;
    };
}

type AdsModerationType = 'FIRST_MODERATION' | 'FIRST_AI_MODERATION';

export const adsModerationDataProvider = {
    getList: async (_resource: string, params: GetListParams): Promise<GetListResult<ModerationAd>> => {
        const moderationType = params.meta?.moderationType as AdsModerationType | undefined;
        const json: ModerationAdsApiResponse = await adsProxy.getList(moderationType || 'FIRST_MODERATION', params);
        const ads = json.body.response.map(ad => ({
            ...ad,
            meta: { cursor: json.body.cursor || null }
        }));
        return {
            data: ads,
            total: ads.length,
            pageInfo: {
                hasNextPage: !!json.body.cursor,
                hasPreviousPage: false
            },
            meta: {
                cursor: json.body.cursor || null
            }
        };
    },
    // getOne, create, update, delete и др. можно реализовать по необходимости
} as DataProvider;

export const adsExpertModerationDataProvider = {
    getList: async (_resource: string, params: GetListParams): Promise<GetListResult<ModerationAd>> => {
        const json: ModerationAdsApiResponse = await adsProxy.getList('EXPERT_MODERATION', params);
        const ads = json.body.response.map(ad => ({
            ...ad,
            meta: { cursor: json.body.cursor || null }
        }));
        return {
            data: ads,
            total: ads.length,
            pageInfo: {
                hasNextPage: !!json.body.cursor,
                hasPreviousPage: false
            },
            meta: {
                cursor: json.body.cursor || null
            }
        };
    },
    // getOne, create, update, delete и др. можно реализовать по необходимости
} as DataProvider; 
